<!--
  Иконка водителя: силуэт человека.
  Обычно используется в карточках и разделах, связанных с водителями.
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="8"
      r="4"
      :stroke="stroke"
      stroke-width="2"
    />
    <path
      d="M4 21C4 16.5817 7.58172 13 12 13C16.4183 13 20 16.5817 20 21"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "DriverIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
